<template>
    <div class="booking-view">
        <v-row>
            <v-col>
                <v-card>
                    <v-tabs fixed-tabs>
                        <v-tab to="/booking/registration/currentMeetings">Aktuelle møder</v-tab>
                        <v-tab to="/booking/registration/currentOffers">Aktuelle tilbud</v-tab>
                        <v-tab to="/booking/registration/all/meetings">Alle møder</v-tab>
                        <v-tab to="/booking/registration/all/offers">Alle tilbud</v-tab>
                        <v-tab to="/booking/registration/all/calendar">Kalender</v-tab>
                    </v-tabs>
                </v-card>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    solo
                    label="Søg efter navn eller telefon..."
                    v-model="$store.state.meetings.searchString"
                    clearable
                    hide-details
                    append-icon="fa-search"
                    :disabled="route === 'BookingAllCalendar'"
                />
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col class="d-flex">
                <v-btn
                class="flex-grow-1"
                solo
                large
                color="green"
                dark
                @click="handleClickCreateMeeting">
                    <v-icon left>
                        fa-plus
                    </v-icon>
                    Opret møde
                </v-btn>
            </v-col>
            <v-col class="d-flex">
                <v-btn
                class="flex-grow-1"
                solo
                large
                color="green"
                dark
                @click="handleClickCreateAdditionalSale">
                    <v-icon left>
                        fa-coins
                    </v-icon>
                    Log mersalg
                </v-btn>
            </v-col>
            <v-col>
                <v-autocomplete
                    solo
                    hide-details
                    prefix="Team:"
                    :disabled="$store.state.main.access === 'tele'"
                    v-model="$store.state.meetings.team"
                    :items="$store.getters['meetings/teams']"
                />
            </v-col>
            <v-col>
                <v-autocomplete
                    solo
                    hide-details
                    prefix="Agentur:"
                    :disabled="$store.state.main.access === 'tele'"
                    v-model="$store.state.meetings.salesAgent"
                    :items="$store.getters['meetings/salesAgents']"
                />
            </v-col>
            <v-col cols="4">
                <range-picker :solo="true" :disabled="searching || route === 'BookingAllCalendar'" storeName="meetings" rangeName="range" periodName="period" :presets="$store.state.meetings.meetingDatePresets" />
            </v-col>
        </v-row>
        <router-view style="margin-bottom: 80px" />
        <div v-if="changedMeetings" class="bottom-drawer primary">
            <div class="wrapper container d-flex justify-end align-center">
                <v-btn @click="updateMeetings">
                    Gem ændringer
                </v-btn>
            </div>
        </div>
        <v-dialog v-model="createMeetingDialog" width="500">
            <v-card class="create-meeting-dialog">
                <v-card-title class="headline" primary-title>
                    Opret møde
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <v-form ref="createMeetingForm" :lazy-validation="true">
                        <v-radio-group
                            label="Mødetype"
                            v-model="newMeeting.type"
                            mandatory
                            row
                        >
                            <v-radio label="Fysisk" value="physical" />
                            <v-radio label="Telefon" value="tele" />
                            <v-radio label="Online" value="online" />
                        </v-radio-group>
                        <v-divider />
                        <v-text-field
                            label="Fornavn"
                            v-model="newMeeting.firstname"
                            :rules="newMeetingRules.firstname"
                        />
                        <v-text-field
                            label="Efternavn"
                            v-model="newMeeting.lastname"
                            :rules="newMeetingRules.lastname"
                        />
                        <v-text-field
                            label="Telefonnummer"
                            v-model="newMeeting.phone"
                            :rules="newMeetingRules.phone"
                            type="number"
                        />
                        <date-picker
                            label="Dato"
                            :date="newMeeting.meetingDate"
                            @updateDate="newMeeting.meetingDate = $event"
                        />
                        <v-text-field
                            label="Mødetidspunkt"
                            v-model="newMeeting.meetingTime"
                            :rules="newMeetingRules.meetingTime"
                        />
                        <v-select
                            label="Agentur"
                            :disabled="$store.state.main.access === 'tele'"
                            v-model="newMeeting.salesAgent"
                            :rules="newMeetingRules.salesAgent"
                            :items="$store.state.meetings.salesAgents"
                        />
                    </v-form>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                    color="primary"
                    text
                    @click="createMeeting">
                        Opret møde
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="createAdditionalSaleDialog" width="500">
            <v-card>
            <v-card-title class="headline" primary-title>
                    Log mersalg
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <v-form ref="createAdditionalSaleForm" :lazy-validation="true">
                        <v-text-field
                            label="Solgt præmie"
                            v-model="newAdditionalSale.value"
                            :rules="newAdditionalSaleRules.value"
                            type="number"
                        />
                        <date-picker
                            label="Dato"
                            :date="newAdditionalSale.date"
                            @updateDate="newAdditionalSale.date = $event"
                        />
                        <v-select
                            label="Agentur"
                            :disabled="$store.state.main.access === 'tele'"
                            v-model="newAdditionalSale.salesAgent"
                            :rules="newAdditionalSaleRules.salesAgent"
                            :items="$store.state.meetings.salesAgents"
                        />
                    </v-form>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                    color="primary"
                    text
                    @click="createAdditionalSale">
                        Log mersalg
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import RangePicker from "@/components/rangePicker"
import DatePicker from '@/components/datePicker.vue'
import moment from 'moment'

export default {
    components: {
        RangePicker,
        DatePicker
    },
    data () {
        return {
            newMeetingRules: {
                firstname: [v => !!v || 'Fornavn skal udfyldes'],
                lastname: [v => !!v || 'Efternavn skal udfyldes'],
                bookingAgentOrgCode: [v => v || 'Booker skal udfyldes'],
                salesAgent: [v => !!v || 'Agentur skal udfyldes'],
                project: [v => v || 'Projekt skal udfyldes'],
                phone: [
                    v => !!v || 'Telefonnummer skal udfyldes',
                    v => (!!v && v.length === 8) || 'Telefonnummer skal være 8 cifre'
                ],
                meetingTime: [v => (!!v && /^\d\d:\d\d$/.test(v)) || 'Mødetidspunktet skal være i formatet HH:MM'],
            },
            newAdditionalSaleRules: {
                value: [v => !!v || 'Solgt præmie skal udfyldes'],
                salesAgent: [v => !!v || 'Agentur skal udfyldes']
            },
            newMeetingTemplate: {
                firstname: null,
                lastname: null,
                phone: null,
                type: null,
                bookingAgentOrgCode: null,
                salesAgent: null,
                meetingDate: moment().format('YYYY-MM-DD'),
                meetingTime: null,
                status: 'open',
                result: null,
                value: null,
                offerClosedDate: null,
                offerStatus: 'open',
                offerResult: null,
                offerValue: null,
                comment: null
            },
            newMeeting: {},
            newAdditionalSaleTemplate: {
                value: null,
                date: moment().format('YYYY-MM-DD'),
                salesAgent: null
            },
            newAdditionalSale: {},
            createMeetingDialog: false,
            createAdditionalSaleDialog: false
        }
    },
    computed: {
        range () {
            return this.$store.state.meetings.range
        },
        period () {
            return this.$store.state.meetings.period
        },
        route() {
            return this.$route.name
        },
        searchString () {
            return this.$store.state.meetings.searchString
        },
        searching () {
            return this.$store.state.meetings.searchString !== null && this.$store.state.meetings.searchString.length > 0
        },
        changedMeetings () {
            return this.$store.state.meetings.changedMeetings
        }
    },
    methods: {
        handleClickCreateMeeting () {
            this.newMeeting = {
                ...this.newMeetingTemplate,
                salesAgent: this.$store.state.main.access === 'tele' ? this.$store.state.meetings.salesAgent : null
            }
            this.createMeetingDialog = true
        },
        handleClickCreateAdditionalSale () {
            this.newAdditionalSale = {
                ...this.newAdditionalSaleTemplate,
                salesAgent: this.$store.state.main.access === 'tele' ? this.$store.state.meetings.salesAgent : null
            }
            this.createAdditionalSaleDialog = true
        },
        async updateMeetings () {
            const updatedMeetings = []
            let errors = false
            this.$store.state.meetings.errors = {}
            Object.keys(this.$store.state.meetings.updatedMeetings).forEach(meetingId => {
                const meeting = this.$store.state.meetings.updatedMeetings[meetingId]
                if (meeting.status === 'completed' && meeting.result === null) {
                    errors = true
                    this.$store.state.meetings.errors.result = ['Du mangler at vælge resultat']
                }
                if (meeting.status === 'completed' && meeting.result === 'sale' && meeting.value === null) {
                    errors = true
                    this.$store.state.meetings.errors.value = ['Du mangler at skrive salgsbeløb']
                }
                if (meeting.status === 'canceled' && meeting.reBookPermission === null) {
                    errors = true
                    this.$store.state.meetings.errors.reBookPermission = ['Du mangler at vælge årsag']
                }
                if (meeting.status === 'complaint' && meeting.comment === null) {
                    errors = true
                    this.$store.state.meetings.errors.comment = ['Du skal skrive en kommentar']
                }
                if (meeting.status === 'completed' && meeting.result === 'offer' && meeting.offerStatus === 'closed' && meeting.offerResult === null) {
                    errors = true
                    this.$store.state.meetings.errors.offerResult = ['Du mangler at vælge resultat']
                }
                if (meeting.status === 'completed' && meeting.result === 'offer' && meeting.offerStatus === 'closed' && meeting.offerResult === 'sale' && meeting.offerValue === null) {
                    errors = true
                    this.$store.state.meetings.errors.offerValue = ['Du mangler at skrive salgsbeløb']
                }
                updatedMeetings.push(meeting)
            })
            if (errors) return null
            this.$store.state.meetings.saving = true
            let response = await this.$http().patch("/booking/registration/meetings", {
                meetings: updatedMeetings
            })
            if (response.status === 200) {
                this.$store.state.meetings.updatedMeetings = {}
                this.$store.state.meetings.saving = false
                this.$store.state.meetings.changes = !this.$store.state.meetings.changes
            }
        },
        async createMeeting () {
            if (this.$refs.createMeetingForm.validate()) {
                await this.$http().post('/booking/registration/meetings', this.newMeeting)
                this.createMeetingDialog = false
                this.$store.state.meetings.changes = !this.$store.state.meetings.changes
            }
        },
        async createAdditionalSale () {
            if (this.$refs.createAdditionalSaleForm.validate()) {
                await this.$http().post('/booking/registration/additionalSales', this.newAdditionalSale)
                this.createAdditionalSaleDialog = false
            }
        }
    },
    watch: {
        range: {
			handler({ length }) {
                if (this.$store.state.meetings.period !== 'I dag' && this.route === 'BookingCurrentMeetings' && length === 2) this.$router.push('/booking/registration/all/meetings')
                else if (this.$store.state.meetings.period !== 'I dag' && this.route === 'BookingCurrentOffers' && length === 2) this.$router.push('/booking/registration/all/offers')
			},
			deep: true
		},
        period: function () {
		    this.$store.commit("meetings/setRange", { range: 'range', preset: this.$store.state.meetings.period });
        },
        searchString: function () {
            if (this.searchString === null || this.searchString.length === 0) return null
            if (this.route === 'BookingCurrentMeetings') this.$router.push( { path: '/booking/registration/all/meetings' })
            else if (this.route === 'BookingCurrentOffers') this.$router.push( { path: '/booking/registration/all/offers' })
        }
    }
}
</script>

<style lang="scss">
.v-card {
    width: 100%;
}

.booking-view {
    .bottom-drawer {
        width: 100%;
        height: 60px;
        position: fixed;
        bottom: 0;
        left: 0;

        .wrapper {
            height: 100%;
        }
    }
}

.create-meeting-dialog {
    legend {
        margin-right: auto;
    }
}

.meeting {
    position: relative;
    background: #FFF6E5;

    .expand-meeting-button {
        position: absolute;
        left: -17px;
        z-index: 999;
    }
    .edit-meeting-button {
        position: absolute;
        right: -17px;
        z-index: 999;
    }
    .hidden {
        display: none !important;
    }

    .changed {

        .theme--light.v-input, .v-select__selection, input, textarea {
            color: #1976d2 !important;
        }
        
    }

    &.expanded {
        border: 1px solid black !important;
    }

    &:nth-of-type(odd) {
        background: #FFFBFB;
    }
}
.v-select__selections {
    line-height: 20px;
}
</style>